import { Button, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import Modal from '@mui/material/Modal';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  REDIRECT_TYPE_EXTERNAL,
  REDIRECT_TYPE_FLOW,
  REDIRECT_TYPE_IN_APP_PAGE,
} from '../../../../../constants/UiBuilderConst';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import IconPicker from '../../../../../shared/ui-builder/icon-picker/Icon-Picker';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  editUiBuilderHamburgerMenu,
  saveUiBuilderHamburgerMenu,
} from '../../../../../utils/UiBuilderAPIUtils';
import {
  allUIBuilderFlowsSelector,
  allUIBuilderPagesSelector,
  fetchAllUIBuilderHamburgerMenu,
  selectedGroupSelector,
} from '../../../../property/propertySlice';
import PageTable from '../PageTable';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const AddHamburgerMenuModal = (props) => {
  const { toggleAddMenuPopup, toggleModal, uiBuilderMenu, hotelId, showLoader = () => {} } = props;
  const pageList = useSelector(allUIBuilderPagesSelector);
  const flows = useSelector(allUIBuilderFlowsSelector);
  const selectedGroup = useSelector(selectedGroupSelector);
  const [pages, setPages] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setPages(pageList);
  }, [pageList]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Item Name',
      errors: {},
      validations: ['required'],
      maxLength: 150,
    },
    category: {
      value: '',
      fieldName: 'Category',
      errors: {},
      validations: ['required'],
    },
    redirect: {
      value: '',
      fieldName: 'Redirect Options',
      errors: {},
      validations: ['required'],
    },
    pageId: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: [],
    },
    external: {
      value: '',
      fieldName: 'External Link',
      errors: {},
      validations: ['validUrl', 'safeURL', 'safeDomain'],
      tab: 0,
    },
    flow: {
      value: '',
      fieldName: 'Flow',
      errors: {},
      validations: [],
      tab: 0,
    },
    menuIconUrl: {
      value: '',
      fieldName: 'Icon',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    const currentFormData = { ...formData };
    currentFormData.name.value = uiBuilderMenu?.name || '';
    currentFormData.category.value = uiBuilderMenu?.category || '';
    currentFormData.redirect.value = uiBuilderMenu?.redirectOptions || '';
    currentFormData.pageId.value = uiBuilderMenu?.pages[0] || '';
    currentFormData.external.value = uiBuilderMenu?.externalLink || '';
    currentFormData.flow.value = uiBuilderMenu?.flow || '';
    currentFormData.menuIconUrl.value = uiBuilderMenu?.menuIconUrl || '';
    setFormData(currentFormData);
  }, [uiBuilderMenu]);

  const onChangePageOption = (currentPage) => {
    const pageId = { ...formData.pageId };
    pageId.value = currentPage.id;
    setFormData({ pageId });
  };

  const validate = (isUpdatedFields) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isUpdatedFields ? updatedFields : false);
    if (isUpdatedFields) setFormData(updatedFields);
    return isValid;
  };

  const onSubmitMenu = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      e.preventDefault();
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      if (!validate(true)) return false;
      toggleModal();
      const payload = {
        hotelId,
        name: formData?.name?.value,
        category: formData?.category?.value,
        redirect: formData?.redirect?.value,
        pageId:
          formData?.redirect?.value === REDIRECT_TYPE_IN_APP_PAGE ? formData?.pageId?.value : '',
        external:
          formData?.redirect?.value === REDIRECT_TYPE_EXTERNAL ? formData?.external?.value : '',
        flow: formData?.redirect?.value === REDIRECT_TYPE_FLOW ? formData?.flow?.value : '',
        menuIconUrl: formData.menuIconUrl.value,
      };
      if (uiBuilderMenu?.id) {
        payload.id = uiBuilderMenu?.id;
        await editUiBuilderHamburgerMenu(payload, language);
      } else await saveUiBuilderHamburgerMenu(payload, language);
      dispatch(fetchAllUIBuilderHamburgerMenu(hotelId));
      notificationManager(
        'success',
        `Menu ${uiBuilderMenu?.id ? 'updated' : 'created'} successfully`,
      );
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : `Error occurred while ${uiBuilderMenu?.id ? 'updating' : 'creating'} menu`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <Modal
      open={toggleAddMenuPopup}
      onClose={() => toggleModal()}
      style={{ width: '80rem', margin: 'auto' }}
    >
      <div>
        <div className='hambuger-add-modal' style={{ height: 'auto' }}>
          <h3>{uiBuilderMenu?.id ? 'Update' : 'Add'} Menu Item</h3>
          <form onSubmit={onSubmitMenu} noValidate>
            <div className='col-md-3 mb-3'>
              <CustomTextField
                item={formData?.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={150}
                characterCount={true}
                endAdornment={true}
              />
            </div>
            <div className='col-md-12'>
              <p className='sub-heading mt-4 mb-0 pb-2'>Icon</p>
            </div>
            <div className='col-md-4'>
              <IconPicker
                groupId={selectedGroup}
                format={'SVG'}
                width={512}
                height={512}
                matrix={'px'}
                onIconSelect={(e) => {
                  setFormData({ menuIconUrl: e });
                }}
                iconURL={formData.menuIconUrl.value}
              />
            </div>
            <div className='col-md-12'>
              <p className='sub-heading mt-4 mb-0'>Category</p>
            </div>
            <div className='col-md-12'>
              <RadioGroup
                row
                aria-label={formData?.category?.fieldName}
                onChange={(e) => {
                  const currField = { ...formData.category };
                  currField.value = e.target.value;
                  setFormData({ category: currField });
                }}
                value={formData?.category?.value}
                name={formData?.category?.fieldName}
                className='mb-3'
              >
                <FormControlLabel
                  value='preCheckIn'
                  control={<Radio color='primary' />}
                  label='Pre Check-in'
                  className='me-5'
                />

                <FormControlLabel
                  value='postCheckIn'
                  control={<Radio color='primary' />}
                  label='Post Check-in'
                  className='me-5'
                />
                <FormControlLabel value='both' control={<Radio color='primary' />} label='Both' />
              </RadioGroup>
            </div>
            <div className='col-md-12'>
              <p className='sub-heading mt-4 mb-0'>Redirect options</p>
            </div>
            <div className='col-md-12'>
              <RadioGroup
                row
                aria-label={formData?.redirect?.fieldName}
                onChange={(e) => {
                  const currField = { ...formData.redirect };
                  currField.value = e.target.value;
                  setFormData({ redirect: currField });
                }}
                value={formData?.redirect?.value}
                name={formData?.redirect?.fieldName}
                className='mb-3'
              >
                <FormControlLabel
                  value='IN_APP'
                  control={<Radio color='primary' />}
                  label='In-App Page'
                  className='me-5'
                />
                <FormControlLabel
                  value='EXTERNAL'
                  control={<Radio color='primary' />}
                  label='External'
                  className='me-5'
                />
                <FormControlLabel value='FLOW' control={<Radio color='primary' />} label='Flow' />
              </RadioGroup>
            </div>
            {formData?.redirect?.value === REDIRECT_TYPE_IN_APP_PAGE && (
              <>
                <div className='col-md-12'>
                  <p className='sub-heading'>Select a page to link this Menu Item</p>
                </div>

                <div className='col-md-11 mb-3 page-table-scroll'>
                  <PageTable
                    pages={pages}
                    formData={formData}
                    onChangePageOption={onChangePageOption}
                  />
                </div>
              </>
            )}
            {formData?.redirect?.value === REDIRECT_TYPE_EXTERNAL && (
              <div className='col-md-9'>
                <CustomTextField
                  item={formData.external}
                  handleInputChange={(e) => {
                    setFormData({ external: e });
                  }}
                  maxLength='2048'
                />
              </div>
            )}
            {formData?.redirect?.value === REDIRECT_TYPE_FLOW && (
              <>
                <div className='col-md-9'>
                  <CustomSelect
                    item={formData.flow}
                    handleInputChange={(e) => {
                      setFormData({ flow: e });
                    }}
                    labelPrefix='Select'
                    options={flows}
                    labelField='label'
                    hideNullOption={flows?.length}
                  />
                </div>
              </>
            )}
          </form>
        </div>
        <div className='hambuger-add-menu-footer'>
          <div className='justify-content-end my-4 row '>
            <div className='col-md-2 btn-right pt-3'>
              <Button
                variant='outlined'
                type='button'
                color='secondary'
                size='large'
                onClick={(e) => toggleModal()}
              >
                Cancel
              </Button>
            </div>
            <div className='col-md-2 pt-3'>
              <Button
                variant='contained'
                type='submit'
                color='primary'
                className='me-3'
                size='large'
                disabled={
                  !validate(false) ||
                  !(
                    (formData?.redirect?.value === REDIRECT_TYPE_IN_APP_PAGE &&
                      formData?.pageId?.value !== '') ||
                    (formData?.redirect?.value === REDIRECT_TYPE_EXTERNAL &&
                      formData?.external?.value !== '') ||
                    (formData?.redirect?.value === REDIRECT_TYPE_FLOW &&
                      formData?.flow?.value !== '')
                  )
                }
                onClick={(e) => {
                  onSubmitMenu(e);
                }}
              >
                {uiBuilderMenu?.id ? 'Update' : 'Add'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddHamburgerMenuModal;
